<template>
    <input id="future_datetime" name="future_datetime" type="text" class="form-control design-datetime-example daterange-single">
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

        props: ['value', 'endDate', 'range', 'time', 'format'],

        data() {
            return {
                datePicker: null,
            };
        },

        watch: {
            value() {
                this.updateValue();
            },
        },

        mounted() {

            let dateInput = $(this.$el);

            dateInput.daterangepicker({
                singleDatePicker: (this.range === false),
                timePicker: (this.time === true),
                locale: {
                    format: 'MM/DD/YYYY h:mm a',
                },
            }, (start, end, label) => {
                this.$emit('input', start);
                this.$emit('update:endDate', end);
                this.$emit('change', start);
            });

            this.datePicker = dateInput.data('daterangepicker');

            this.updateValue();

        },

        methods: {
            updateValue() {

                if (this.datePicker) {
                    this.datePicker.setStartDate(moment(this.value));
                    this.datePicker.setEndDate(moment(this.endDate ? this.endDate : this.value));
                }

            },
        },

    }
</script>

